import { FC } from "react";
import { RaffleCard, getRaffleRole } from "entities/wheel-raffle";
import type { RaffleBase } from "entities/wheel-raffle";

import styles from "./RaffleCardList.module.css";

interface Props {
  items: RaffleBase[];
  emptyText: string;
  isLoading?: boolean;
  isFetching?: boolean;
  errorMessage?: string | null;
  onOpenRaffle: (raffleId: number) => void;
}

// Карточки подсвечены ролью зрителя: создал или участвует.
export const RaffleCardList: FC<Props> = ({
  items,
  emptyText,
  isLoading,
  isFetching,
  errorMessage,
  onOpenRaffle,
}) => {
  if (isLoading) return <p className={styles.placeholder}>Loading...</p>;
  if (errorMessage && !items.length) {
    return <p className={styles.placeholder}>{errorMessage}</p>;
  }
  if (!items.length) return <p className={styles.placeholder}>{emptyText}</p>;

  return (
    <ul className={`${styles.list} ${isFetching ? styles.fetching : ""}`}>
      {items.map((raffle) => (
        <li key={raffle.id}>
          <RaffleCard
            raffle={raffle}
            role={getRaffleRole(raffle)}
            onClick={onOpenRaffle}
          />
        </li>
      ))}
    </ul>
  );
};
